import { CSSProperties } from 'react';

import { Response } from '../../../services/backendService/types';
import LiveGameImage from '../LiveGameImage';

const LazyDrawingResponse = ({
  onClick,
  response,
  style = { height: '100%', width: '100%', background: 'white' },
  boxShadow,
  tenantId,
}: {
  onClick: (s: string) => void;
  response: Response;
  hide?: boolean;
  boxShadow?: string;
  style?: CSSProperties;
  tenantId: string;
}) => {
  if (!response.response) return null;
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LiveGameImage
        imageId={response.response}
        style={style}
        objectFit="contain"
        tenantId={tenantId}
        modifiedAt={response.modifiedAt}
        fluid
        isAuthenticated={false}
        onImageClicked={onClick}
        boxShadow={boxShadow}
      />
    </div>
  );
};
export default LazyDrawingResponse;
